module.exports = __webpack_public_path__ + "js/0.574f8ad7.worker.js"